import { ReactNode } from "react";

interface FormItemProps {
  label?: string,
  top?: boolean,
  required?: boolean,
  children: ReactNode

}
const FormItem = ({ label, top, required = false, children }: FormItemProps) => {
  return (
    <div
      className={`sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start ${top ? "pt-0" : "sm:border-t"
        } sm:border-gray-200 py-5`}
    >
      <label
        htmlFor={`${label}`}
        className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
      >
        {label}{required && <span className="text-red-500 ml-1">*</span>}
      </label>

      <div className="mt-1 sm:mt-0 sm:col-span-2">
        {children}
      </div>
    </div>
  );
};
export default FormItem;
